export const apiEndpoints = {
    Layout: {},
    Faq: {
        GetAll: {url: "/faqs", method: "GET"},
        Add: {url: '/faqs', method: 'POST'},
        Edit: {url: (id: string) => `/faqs/${id}`, method: 'PUT'},
        Delete: {url: (id: string) => `/faqs/${id}`, method: 'DELETE'},
    },
    Isaco: {
        GetAll: {url: "/Isaco", method: "GET"},
    },
    News: {
        GetAll: {url: "/news", method: "GET"},
    },
    BankPayment: {
        Request: {url: "/Payment/Request", method: "POST"},
    },
    User: {
        GetRoles: {url: '/roles', method: 'GET'},
        AddRole: {url: '/roles', method: 'POST'},
        DeleteRole: {url: '/roles', method: 'DELETE'},
        GetProfile: {url: '/user/profile', method: 'GET'},
        GetProfilePictureName: {url: '/user/profile/picture', method: 'GET'},
        SetProfilePicture: {url: '/user/profile/picture', method: 'PATCH'},
        SendRegisterVerificationCode: {url: '/user/sms/register', method: 'POST'},
        SendForgotPasswordVerificationCode: {url: '/user/sms/forgot-Password', method: 'POST'},
        CheckVerificationCode: {url: '/user/sms/check', method: 'POST'},
        Register: {url: '/user/register', method: 'POST'},
        Login: {url: '/user/login', method: 'POST'},
        ResetPassword: {url: '/user/reset-password', method: 'POST'},
        ChangePassword: {url: '/user/change-password', method: 'POST'},
        RefreshToken: {url: '/user/refresh-token', method: 'POST'},
        RevokeToken: {url: '/user/revoke-token', method: 'POST'},
        DeleteUser: (id: string) => ({url: `/user/${id}`, method: 'DELETE'}),
        UploadProfileImage: {url: '/user/upload-profile-image', method: 'POST'},
        SetMainImage: (imageId: string) => ({url: `/user/image/${imageId}/set-main`, method: 'PATCH'}),
        RemoveImage: (imageId: string) => ({url: `/user/image/${imageId}`, method: 'DELETE'}),
        GetFavorites: {url: '/user/favorites', method: 'GET'},
        AddAnonymousUser: {url: '/users/anonymous', method: 'POST'},
        EditProfile: (id: string) => ({url: `user/profile`, method: 'PATCH'}),
        AssignRole: (id: string) => ({url: `/users/${id}/roles`, method: 'POST'}),
        TakeBackRole: (id: string) => ({url: `/users/${id}/roles`, method: 'DELETE'}),
        BlockUser: (targetUserId: string) => ({url: `/users/${targetUserId}/block`, method: 'PATCH'}),
        UnblockUser: (targetUserId: string) => ({url: `/users/${targetUserId}/unblock`, method: 'PATCH'}),
        GetUsersAdmin: (queryString = '') => ({url: `/users?${queryString}`, method: 'GET'}),
        GetProfileUser: (id: string) => ({url: `/users/${id}/profile`, method: 'GET'}),
        EditProfileUser: (id: string) => ({url: `/users/${id}/profile`, method: 'PATCH'}),
        SetProfilePictureUser: (id: string) => ({url: `/users/${id}/profile/picture`, method: 'PATCH'}),

    },

    Cart: {
        GetCart: {url: '/cart', method: "GET"},
        GetGiftAmount: {url: '/cart/gift-amount', method: "GET"},
        GetCartItemsCount: {url: "/cart/count", method: "GET"},
        Add: {url: '/cart/products', method: "POST"},
        Edit: {url: '/cart/products', method: "PATCH"},
        Remove: {url: '/cart/products', method: "DELETE"},
        Confirm: {url: '/cart', method: "POST"},
    },
    Product: {
        ProductGroup: {
            Groups: {url: "/products/groups", method: "GET"},
        },
        GetLatestCompanies: {
            url: '/products/groups/latest-companies',
            method: 'GET',
        },
        EditImagesFromDisk: {
            url: '/products/groups/images/from-disk',
            method: 'POST',
        },
        GetOffers10: {
            url: '/products/offers10',
            method: 'GET',
        },
        GetNewests10: {
            url: '/products/newests10',
            method: 'GET',
        },
        GetSuggestions: {
            url: (searchText: string) => `/products/suggestions?searchText=${encodeURIComponent(searchText)}`,
            method: 'GET',
        },
        GetAllIds: {
            url: '/products/ids',
            method: 'GET',
        },
        GetPrediction: {
            url: (searchText = "") => `/product/getPrediction?searchText=${searchText}`,
            method: "GET",
        },
        GetUpdateDateTime: {
            url: '/products/last-update',
            method: 'GET',
        },
        GetProductPriceChart: {
            url: (id: string) => `/products/${id}/price-chart`,
            method: 'GET',
        },
        GetDetails: {
            url: (id: string) => `/products/${id}/details`,
            method: 'GET',
        },
        Offers: {
            AddOffer: {
                url: (id: string, discount: number) => `/products/${id}/offers?discount=${discount}`,
                method: 'POST',
            },
            DeleteOffer: {
                url: (id: string) => `/products/${id}/offers`,
                method: 'DELETE',
            },
        },
        Comments: {
            GetAdminComments: {
                url: '/users/products/comments',
                method: 'GET',
            },
            GetUserComment: {
                url: (id: string) => `/users/${id}/products/comments`,
                method: 'GET',
            },
            GetComments: {
                url: '/products/comments',
                method: 'GET',
            },
            GetUserCommentsCount: {
                url: (id: string) => `/users/${id}/products/comments/count`,
                method: 'GET',
            },
            GetAdminCommentsCount: {
                url: '/users/products/comments/count',
                method: 'GET',
            },
            GetCommentsCount: {
                url: '/products/comments/count',
                method: 'GET',
            },
            AddComment: {
                url: (id: string) => `/products/${id}/comments`,
                method: 'POST',
            },
            DeleteComment: {
                url: (commentId: string) => `/products/comments/${commentId}`,
                method: 'DELETE',
            },
        },

        // Images
        Images: {
            GetImages: {
                url: (id: string) => `/products/${id}/images`,
                method: 'GET',
            },
            DownloadImages: {
                url: (id: string) => `/products/${id}/images/download`,
                method: 'GET',
            },
            AddImages: {
                url: (id: string) => `/products/${id}/Images`,
                method: 'POST',
            },
            EditImageActive: {
                url: (pictureId: string, isActive: boolean) =>
                    `/products/images/${pictureId}/${isActive}`,
                method: 'PATCH',
            },
            DeleteImage: {
                url: (pictureId: string) => `/products/images/${pictureId}`,
                method: 'DELETE',
            },
            AddImagesFromDisk: {
                url: '/products/images/from-disk',
                method: 'POST',
            },
        },

        // Products
        GetProducts: {
            url: (queryString = '') => `/products${queryString ? `?${queryString}` : ''}`,
            method: 'GET',
        },
    },
    Finance: {
        GetFinance: {url: '/user/finance', method: 'GET'},
        GetUserFinance: (userId: string) => ({url: `/users/${userId}/finance`, method: 'GET'}),
        GetBalance: {url: '/user/finance/balance', method: 'GET'},
        GetUserBalance: (userId: string) => ({url: `/users/${userId}/finance/balance`, method: 'GET'}),
        GetBalanceAdmin: (userId: string) => ({url: `/users/${userId}/finance/balance`, method: 'GET'}),
        GetAdminCalendarEvents: {url: "/users/finance/calendar-events", method: "GET"},
        GetCalendarEvents: {url: '/user/finance/calendar-events', method: 'GET'},
        GetCalendarEventsAdmin: {url: (id: string) => `/users/${id}/finance/calendar-events`, method: 'POST'},
        GetSettleDeadline: {url: '/user/finance/settle-days', method: 'GET'},
    },
    FactorCheck: {
        UpdateTransport: {url: (id: string) => `/factor-checks/${id}/transport`, method: "PATCH",},
        DeleteTransport: {url: (id: string) => `/factor-checks/${id}/transport`, method: "DELETE",},
        GetTransportAccounts: {url: "/factor-checks/transport/accounts", method: "GET",},
        GetFactorSend: {url: (id: string) => `/factors/${id}/send`, method: 'GET'},

        GetFactorChecks: {url: '/factor-checks', method: 'GET'},
        GetFactors: {url: '/factor-checks/factors', method: 'GET'},
        Add: {url: '/factor-checks', method: 'POST'},
        Restore: {url: (id: string) => `/factor-checks/${id}/restore`, method: 'POST'},
        Send: {url: (id: string) => `/factor-checks/${id}/transport`, method: 'POST'},
        Finish: {url: (id: string) => `/factor-checks/${id}/finish`, method: 'POST'},
        Edit: {url: (id: string) => `/factor-checks/${id}/description`, method: 'PATCH'},
        Delete: {url: (id: string) => `/factor-checks/${id}`, method: 'DELETE'},
        GetFactorCheck: {url: (id: string) => `/factor-checks/${id}`, method: 'GET'},
        GetFactorsId: {url: (id: string) => `/factor-checks/${id}/factors`, method: 'GET'},
        EditFactors: {url: (id: string) => `/factor-checks/${id}/factors`, method: 'PATCH'},
        GetItems: {url: (id: string) => `/factor-checks/${id}/items`, method: 'GET'},
        EditItemCount: {url: (id: string) => `/factor-checks/${id}/items`, method: 'PATCH'},
        GetFactorPrint: {url: (id: string) => `/factors/${id}/print`, method: 'GET'},

    },

    InventoryCounts: {
        GetInventoryCounts: {url: `/store-checks`, method: 'GET',},
        GetInventoryCountItems: {url: (id: string) => `/store-checks/${id}/items`, method: 'GET'},
        GetInventoryCount: {url: (id: string) => `/store-checks/${id}`, method: 'GET'},
        AddInventoryCounts: {url: `/store-checks`, method: 'POST',},
        EditInventoryCountItems: {url: (id: string) => `/store-checks/last/items`, method: 'PATCH'},
        DeleteInventoryCountItems: {url: (id: string) => `/store-checks/${id}`, method: 'DELETE'},
        FinishInventoryCountItems: {url: (id: string) => `/store-checks/${id}/finish`, method: 'POST'},
        RestoreInventoryCountItems: {url: (id: string) => `/store-checks/${id}/restore`, method: 'POST'},

    },
    Messenger: {
        GetUserChatList: {url: `/chats`, method: 'GET',
        },
        GetAnonymousChatList: {
            url: (anonymousUserId: string) => `/anonymous-users/${anonymousUserId}/chats`,
            method: 'GET',
        },
        AddMessage: {
            url: (chatId: string) =>
                `/chats/${chatId}/messages`,
            method: 'POST',
        },
        AddAnonymousMessage: {
            url: (anonymousUserId: string, chatId: string) =>
                `/anonymous-users/${anonymousUserId}/chats/${chatId}/messages`,
            method: 'POST',
        },
        GetChatMeta: {
            url: (chatId: string) =>
                `/chats/${chatId}/meta`,
            method: 'GET',
        },
        GetMessages: {
            url: (chatId: string) =>
                `/chats/${chatId}/messages`,
            method: 'GET',
        },
        GetAnonymousMessages: {
            url: (anonymousUserId: string, chatId: string) =>
                `/anonymous-users/${anonymousUserId}/chats/${chatId}/messages`,
            method: 'GET',
        },
        ReadMessage: {
            url: (chatId: string, messageId: string) =>
                `/chats/${chatId}/messages/${messageId}/seen`,
            method: 'PATCH',
        },
        DeleteMessage: {
            url: (messageId: string) =>
                `/chats/messages/${messageId}`,
            method: 'DELETE',
        },
        EditMessageText: {
            url: (chatName: string, messageId: string) =>
                `/chats/${chatName}/messages/${messageId}/text`,
            method: 'PATCH',
        },
        GetAllMessengerUsers: {
            url: '/chats/users',
            method: 'GET',
        },
        GetMessageTargetPage: {
            url: (chatId: string, messageId: string | number) =>
                `/chats/${chatId}/messages/${messageId}/targetPage`,
            method: "GET",
        },
    },
    Notification: {
        GetNotifications: {
            url: '/notifications',
            method: 'GET',
        },
        AddNotifications: {
            url: '/notifications',
            method: 'POST',
        },
        DeleteNotification: {
            url: (id: string) => `/notifications/${id}`,
            method: 'DELETE',
        },
        ViewNotification: {
            url: (id: string) => `/notifications/${id}/view`,
            method: 'GET',
        },
        AddSubscription: {
            url: '/notifications/subscriptions',
            method: 'POST',
        },
        RemoveSubscription: {
            url: '/notifications/subscriptions',
            method: 'DELETE',
        },
    },
    Order: {
        GetOrders: {
            url: (queryString = 'normalOrders=true') => `/user/orders?${queryString}`,
            method: 'GET',
        },
        GetAdminOrders: {
            url: (queryString = 'normalOrders=true') => `/users/orders?${queryString}`,
            method: 'GET',
        },
        GetUserOrders: {
            url: (id: string, queryString = 'normalOrders=true') => `/users/${id}/orders?${queryString}`,
            method: 'GET',
        },
        GetOrder: {
            url: (id: string) => `/user/orders/${id}`,
            method: 'GET',
        },
        GetOrderAdmin: {
            url: (id: string) => `/users/orders/${id}`,
            method: 'GET',
        },
        GetItems: {
            url: (id: string) => `/orders/${id}/items`,
            method: 'GET',
        },
        GetOrdersTransport: {
            url: (id: string) => `/user/orders/${id}/transport`,
            method: 'GET',
        },
        Confirm: {
            url: (id: string) => `/user/orders/${id}/confirm`,
            method: 'POST',
        },
        Deliver: {
            url: (id: string) => `/user/orders/${id}/deliver`,
            method: 'POST',
        },
        Reject: {
            url: (id: string) => `/user/orders/${id}/reject`,
            method: 'POST',
        },
    },

    Payment: {
        GetCardToCards: {
            url: '/card-to-cards',
            method: 'GET',
        },
        Add: {
            url: '/card-to-cards',
            method: 'POST',
        },
    },
};
